import { idCardUtil } from './idCardRules'

export default {
    // 手机号码
    checkPhone (value) {
        const isPhone = /^1[3456789][0-9]{9}$/
        return isPhone.test(value)
    },
    // 电子邮箱
    checkEmail (value) {
        // eslint-disable-next-line no-useless-escape
        const isMail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
        return isMail.test(value)
    },
    // 移动电话/座机/手机号码
    checkTel (value) {
        let isMob= /^0[0-9-]{10,13}$/
        let isTel = /^(0\d{2,3}\\-)?([2-9]\d{6,7})+(\\-\d{1,6})?$/
        return (isMob.test(value) || isTel.test(value)) || this.checkPhone(value)
    },
    // 身份证号
    checkIdCard (value) {
        // 15位和18位身份证号码的基本校验
        const check = /^\d{15}|(\d{17}(\d|x|X))$/.test(value)
        if (!check) return false
        // 判断长度为15位或18位
        if (value.length === 15) {
            return idCardUtil.check15IdCardNo(value)
        } else if (value.length === 18) {
            return idCardUtil.check18IdCardNo(value)
        } else {
            return false
        }
    },
    // 统一社会信用代码
    checkSocietyCreditCode (value) {
        // eslint-disable-next-line no-useless-escape
        const isSCC = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/
        return isSCC.test(value)
    },
    // 护照(包括香港澳门)
    checkPassport (value) {
        // eslint-disable-next-line no-useless-escape
        const isPass = /(^[EeKkGgDdSsPpHh]\d{8}$)|(^(([Ee][a-fA-F])|([DdSsPp][Ee])|([Kk][Jj])|([Mm][Aa])|(1[45]))\d{7}$)/
        return isPass.test(value)
    },
    // 银行卡号
    checkBankCard (value) {
        // eslint-disable-next-line no-useless-escape
        const isBC = /^([1-9]{1})(\d{15}|\d{18})$/
        return isBC.test(value)
    },
    // 车牌号
    checkCarNo (value) {
        // eslint-disable-next-line no-useless-escape
        const isCN = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/
        return isCN.test(value)
    }
}
